import React, {useState,useEffect,useRef} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Loading } from '@gull';
import FacturationNew from "../../../app/views/Pdf/FacturationNew"
import axios from 'axios';
import swal from "sweetalert2";

const useLoad = (id, token) =>{
    const t = useTranslate();
    const [loading,setLoading]=useState(true)
    const [allInfos,setAllInfos] = useState(false) 
    const [companyInfos,setCompanyInfos] = useState({}) 
    const [clientDetail,setClientDetail]=useState({})
    const [itemsBilling,setItemsBilling]=useState([])
    const [datasPdf,setDatasPdf]=useState([])
    const [error404,setError404]=useState(false)

    const devise = useRef(null)

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/facture/invoice_public/get_one/"+id+'/'+token
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                    setLoading(false)
                }else{
                    setAllInfos(response.data.data)
                    if(response.data.data.other_company_id!=null){
                        setCompanyInfos(response.data.data.other_company)
                    }else{
                        setCompanyInfos(response.data.data.company)
                    }
                    devise.current = response.data.data.company.devise
                    setItemsBilling(response.data.data.facture_article_list)
                    setDatasPdf(response.data.data.facture_article_list_pdf)
                    setClientDetail(response.data.data.client)
                    setLoading(false)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                if(error.response && error.response.status==403) setError404(true)
                swal.fire(t('unknowError'), "", "error");
                setLoading(false)
            })
        })()
    }, [])

    return [loading,allInfos,companyInfos,clientDetail,itemsBilling,error404,datasPdf,devise]
}


const PublicVisualDocument = ({id,token}) => {
    const t = useTranslate();
    const [loading,allInfos,companyInfos,clientDetail,itemsBilling,error404,datasPdf,devise] = useLoad(id, token)
    const iframeRef = useRef(null);
    // const { authParam } = useContext(IsAuthContext);
    // const moduleFacturation = authParam.modules.find(value=>value.name=='invoice')
    let digit = (companyInfos.advanceparams && companyInfos.advanceparams.hasOwnProperty('ventilation_espece') && companyInfos.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    useEffect(() => {
        // Définir un délai en millisecondes
        const delay = 500; // Par exemple, 500 ms
    
        // Utiliser setTimeout pour retarder l'exécution
        const timer = setTimeout(async () => {
            if(!loading){
                const pdfBlob = await FacturationNew({
                    t:t,
                    documentType:allInfos.type,
                    companyInfos:companyInfos,
                    // billing:itemsBilling,
                    billing:datasPdf,
                    clientDetail:clientDetail,
                    devise:devise.current,
                    digit:digit,
                    allInfos:allInfos,
                    columnShow:(allInfos.column_pdf) ? allInfos.column_pdf.split(',') : [],
                    recapShow:(allInfos.recap_pdf) ? allInfos.recap_pdf.split(',') : [],
                    moduleFacturation: allInfos.module.invoice
                });
        
                const pdfUrl = URL.createObjectURL(pdfBlob);
                if (iframeRef.current) {
                    iframeRef.current.src = pdfUrl;
                }
            }
        }, delay);
    
        // Nettoyage de l'effet pour annuler le timer en cas de changement rapide de columnShow
        return () => clearTimeout(timer);
    
    }, [loading]);

    if(loading){
        return(
            <Loading></Loading>
        )
    }

    return(
        <div className='m-3'>
            {!error404 ?
                <div>
                    {(Object.keys(allInfos).length!=0) ?
                        <>
                            <iframe
                                ref={iframeRef}
                                width="100%"
                                height="1000px"
                                title="Aperçu du PDF"
                                style={{ border: 'none', marginTop: '20px' }}
                            ></iframe>
                        </>
                        :
                        false                               
                    }
                </div>
            :
                <div className="not-found-wrap text-center">
                    <h1 className="text-60">404</h1>
                    <p className="text-36 subheading mb-3">Error!</p>
                    <p className="mb-5  text-muted text-18">
                        {t('error404Msg')}
                    </p>
                </div>
            }
        </div>
    )
}

export default PublicVisualDocument;